import { format as defaultFormat } from 'date-fns';
import { fr } from 'date-fns/locale';

export const formatDate = (date: Date | string, formatStr = 'PP'): string =>
  defaultFormat(date, formatStr, { locale: fr });
